/**
 * @generated SignedSource<<41e2da99d0214e84aefcb10af346b144>>
 * @relayHash cc577d3f855af6bfb6475749f0910565
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c6fdb04257953e54a3fbe49f98181b7f2f2706468871df43dc9b49a2fd48855

import type { ConcreteRequest } from 'relay-runtime';
export type useIsImportedPageQuery$variables = {
  contentId?: string | null | undefined;
};
export type useIsImportedPageQuery$data = {
  readonly singleContent: {
    readonly ancestors: ReadonlyArray<{
      readonly title: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly history: {
      readonly createdDate: string | null | undefined;
    } | null | undefined;
    readonly subType: string | null | undefined;
  } | null | undefined;
};
export type useIsImportedPageQuery = {
  response: useIsImportedPageQuery$data;
  variables: useIsImportedPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "subType"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "concreteType": "History",
  "kind": "LinkedField",
  "name": "history",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "createdDate"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsImportedPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsImportedPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "cc577d3f855af6bfb6475749f0910565",
    "id": "4c6fdb04257953e54a3fbe49f98181b7f2f2706468871df43dc9b49a2fd48855",
    "metadata": {},
    "name": "useIsImportedPageQuery",
    "operationKind": "query",
    "text": "query useIsImportedPageQuery($contentId:ID){singleContent(id:$contentId){subType,ancestors{title,id},history{createdDate},id}}"
  }
};
})();

(node as any).hash = "068e36719373d2dbc7edbdc9d8ab7a73";

export default node;
